import { t } from 'i18next';
import toast from 'react-hot-toast';
import { toastStyles } from '../../utils/utils';

export interface ICountryCodeReponse {
  ok: boolean;
  status: number;
  json: Function;
  country: string;
}

export default async function getCountryCode() {
  const response = await fetch(
    `https://ipinfo.io/json?token=${process.env.REACT_APP_IP_INFO_TOKEN}`
  );
  return response;
}

export async function downloadImage(url: string, text: string) {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const downloadurl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = downloadurl;
    a.download = text;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(downloadurl);
  } catch (error) {
    toast.error(t('bookings.bookingSettings.downloadFailed'), toastStyles.error);
  }
}
